import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.97 11.764a1 1 0 0 1 .563 1.204l-.04.11-3.266 7.599a4 4 0 1 1-1.89-.663l3.318-7.726a1 1 0 0 1 1.314-.524ZM16 3c7.732 0 14 6.268 14 14 0 3.546-1.325 6.885-3.665 9.444l-.254.27-1.44-1.387A11.954 11.954 0 0 0 28 17c0-6.627-5.373-12-12-12S4 10.373 4 17c0 3.055 1.145 5.927 3.168 8.124l.246.26-1.43 1.397A13.955 13.955 0 0 1 2 17C2 9.268 8.268 3 16 3Zm0 19a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcDashboard;
